import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import {
  DEFAULT_PHONE_DIAL_CODE,
  formatPhoneAccount,
  getPhoneDialSelectOptions,
  getPhoneDialConfig,
  isNationalNumberValid,
} from '@/constants/phoneDialCodes'
import { Form, FormInstance, Input, Select, Space } from 'antd'
interface PhoneFormProps {
  form: FormInstance<any>;
  codeLoading: boolean;
  countdown: number;
  sendCaptcha: (account: string) => Promise<boolean>;
}

const PhoneForm = (props: PhoneFormProps) => {
  const { codeLoading, countdown, sendCaptcha, form } = props;
  const { t } = useTranslation()

  const handleSendCode = async () => {
    form.validateFields(['phoneDialCode', 'phone']).then((values) => {
      sendCaptcha(formatPhoneAccount(values.phoneDialCode, values.phone))
    })
  }

  return (
    <>
      <Form.Item
        required
        label={<LangText lngKey='fa510eac' className='text-[16px] font-bold'>{t('fa510eac')}</LangText>}
      >
        <Space.Compact className='w-full'>
          <Form.Item name='phoneDialCode' noStyle initialValue={DEFAULT_PHONE_DIAL_CODE}>
            <Select
              options={getPhoneDialSelectOptions()}
              className='!w-[100px]'
              disabled={codeLoading}
              onChange={() => {
                form.validateFields(['phone']).catch(() => undefined)
              }}
            />
          </Form.Item>
          <Form.Item
            name='phone'
            noStyle
            rules={[
              { required: true, message: t('563a19cb') },
              {
                validator: (_, value) => {
                  const dial = form.getFieldValue('phoneDialCode') ?? DEFAULT_PHONE_DIAL_CODE
                  if (!value || !String(value).trim()) {
                    return Promise.resolve()
                  }
                  if (!isNationalNumberValid(dial, String(value))) {
                    const key = getPhoneDialConfig(dial).invalidMessageLngKey ?? '0db00d4c'
                    return Promise.reject(new Error(t(key)))
                  }
                  return Promise.resolve()
                },
              },
            ]}
          >
            <Input placeholder={t('39dfe809')} className='h-[44px]' disabled={codeLoading} />
          </Form.Item>
        </Space.Compact>
      </Form.Item>
      {/* <Form.Item
        name='phone'
        required
        validateTrigger='onBlur'
        label={<LangText lngKey='fa510eac' className='text-[16px] font-bold'>{t('fa510eac')}</LangText>}
        rules={[
          { required: true, message: t('563a19cb') },
          { pattern: /^1[3-9]\d{9}$/, message: t('0db00d4c') }
        ]}
      >
        <Input placeholder={t('39dfe809')} className='h-[44px]' disabled={codeLoading}  />
      </Form.Item> */}
      <Form.Item required className='w-full' label={<LangText lngKey='2638a4d4' className='text-[16px] font-bold'>{t('2638a4d4')}</LangText>}>
        <div className='flex w-full'>
          <Form.Item name='code' noStyle className='flex-1' rules={[{ required: true, message: t('b68e8285') }]}>
            <Input placeholder={t('da67c20b')} className='h-[44px]' />
          </Form.Item>
          <div
            className={`shrink-0 border border-[#3984FF] rounded-[4px] ml-2 px-3 flex items-center justify-center cursor-pointer ${countdown > 0 || codeLoading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            onClick={handleSendCode}
          >
            <LangText lngKey={codeLoading ? '141d18c7' : 'fbdf3b19'} className='text-[14px] text-[#3984FF] text-nowrap'>
              {codeLoading ? t('141d18c7') : countdown > 0 ? `${countdown}s` : t('fbdf3b19')}
            </LangText>
          </div>
        </div>
      </Form.Item>
    </>
  )
}

export default PhoneForm